import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { APP_VARIABLES_TOKEN, AppVariables } from '@tablesready/frontend-variables';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  constructor(
    private readonly pageTitleService: Title,
    @Inject(APP_VARIABLES_TOKEN) private readonly appVariables: AppVariables,
  ) { }

  setTitle(title: string, canonicalUrl?: string): void {
    this.pageTitleService.setTitle(`${title} | ${this.appVariables.WHITELABEL_BRAND}`);
    this.updateCanonicalUrl(canonicalUrl);
  }

  private updateCanonicalUrl(url: string): void {
    const head = document.querySelector('head');
    const existingCanonicalLink = head?.querySelector('link[rel="canonical"]');

    if (existingCanonicalLink) {
      head?.removeChild(existingCanonicalLink);
    }

    if (url) {
      const canonicalUrl = document.createElement('link');
      canonicalUrl.setAttribute('rel', 'canonical');
      canonicalUrl.setAttribute('href', `${this.appVariables.WHITELABEL_HOSTNAME}${url}`);
      head?.appendChild(canonicalUrl);
    }
  }
}
